module.exports = __webpack_public_path__ + "media/team/Cody-Thumbnail-6adfccba.png";